<template>
  <el-table-column
    prop="weight"
    sortable="custom"
    label="Össztömeg"
    show-overflow-tooltip
    min-width="140"
  >
    <template slot-scope="scope">
      {{ scope.row.weight.toFixed(2) | bigNumber }} kg
    </template>
  </el-table-column>
</template>

<script>
export default {
  propName: 'weight',
};
</script>
